import React from 'react'
import {Input} from 'reactstrap'
import {getIn} from 'formik'

const SelectComponent = (props) => {
  const {
    name,
    label,
    options,
    disabled,

    // Formik's context
    formik: {
      values,
      handleChange,
      handleBlur,
    },
  } = props

  const value = getIn(values, name)

  return (
    <Input
      type='select'
      name={name}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={disabled}
    >
      <option value=''>{label}</option>

      {options.map((option, index) => (
        <option
          key={index}
          value={option.value}
        >
          {option.label}
        </option>
      ))}
    </Input>
  )
}

export default SelectComponent
